import Api from '../api';

const { axios: api } = Api;

export const saveCookieConsent = async (payload) => {
	const { data } = await api.post('/cookie-consent', payload);
	return data;
};
